import get from 'lodash/get';
import { useState } from 'react';
import sad from '../../../_shared/assets/sad.svg';
import { ml } from '../../../_shared/services/utils.js';
import {
	formatLeaderboardPoints,
	formatLeaderboardPosition,
} from '../../../_shared/services/leaderboard.js';
import { COLORS } from '../../../_shared/styles/colors';
import { emptyTile } from './leaderBoardStyles.js';

export const EmpLeaderBoard = ({
	title,
	height,
	allMultiLingualData,
	currentUser,
	referralTotalLeaderboard,
	referralPointsLeaderboard,
	isLoading = false,
}) => {
	// The API returns null for a leaderboard the user doesn't qualify for, so
	// company settings like pointsSettings.enabled are already accounted for.
	const showReferrals = Boolean(referralTotalLeaderboard);
	const showPoints = Boolean(referralPointsLeaderboard);

	const [activeTab, setActiveTab] = useState('referrals');

	// Either tab can vanish whenever the query refetches, so clamp to what's
	// actually available instead of trusting activeTab. Deriving rather than
	// syncing state also covers the first render, when both leaderboards are
	// still null and no tab is available yet.
	const availableTabs = [
		showReferrals && 'referrals',
		showPoints && 'points',
	].filter(Boolean);

	if (availableTabs.length === 0) {
		return null;
	}

	const selectedTab = availableTabs.includes(activeTab)
		? activeTab
		: availableTabs[0];

	const entries =
		(selectedTab === 'referrals'
			? referralTotalLeaderboard
			: referralPointsLeaderboard) ?? [];
	const showEmpty = !isLoading && entries.length === 0;

	return (
		<div className={`d-card ${height === 'height-equal' ? 'height-equal' : ''}`}>
			<div className="d-card-head">
				<h4 className="d-title">{title}</h4>
			</div>

			<div className="tabs">
				{showReferrals && (
					<span
						className={selectedTab === 'referrals' ? 'active' : ''}
						onClick={() => setActiveTab('referrals')}
					>
						{ml('Referrals', currentUser, allMultiLingualData)}
					</span>
				)}
				{showPoints && (
					<span
						className={selectedTab === 'points' ? 'active' : ''}
						onClick={() => setActiveTab('points')}
					>
						{ml('Points', currentUser, allMultiLingualData)}
					</span>
				)}
			</div>

			{showEmpty ? (
				<div className={emptyTile}>
					<div>
						<img
							src={sad}
							height={60}
							width={60}
							alt="Sad Face. No employees yet."
						/>
						<div style={{ marginTop: '10px' }}>
							Uh oh. You haven&#39;t added any employees yet. Don&#39;t worry,
							just
							<a style={{ color: COLORS.blue }}> click here </a> to add them!
						</div>
					</div>
				</div>
			) : (
				<ol className="list-data-wrap">
					{entries.slice(0, 10).map((entry) => (
						<li key={entry.position}>
							<label style={entry.isUser ? { color: '#018dd3' } : {}}>
								{formatLeaderboardPosition(entry)}
								{'. '}&nbsp;
								{get(entry, 'fullName', '').split('', 21)}
							</label>
							<span>{formatLeaderboardPoints(entry)}</span>
						</li>
					))}
				</ol>
			)}
		</div>
	);
};
